import { Box, Button } from "@mui/material"

export default function StartGameButton({
  disabled = false,
  onStart = () => {},
  text = "",
}) {
  return (
    <Box
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 20,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <Button
        variant="contained"
        disableElevation
        disabled={disabled}
        sx={{
          borderRadius: 20,
          textTransform: "none",
          animation: "animation_pulse linear 2s infinite",
        }}
        onClick={onStart}
      >
        {text}
      </Button>
    </Box>
  )
}
